import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { isTokenExpired } from './utils/tokenExpiry';
import { logout } from './features/auth/authSlice';
import { toast } from 'sonner';

const ProtectedRoute = () => {
  const { isAuthenticated, loading } = useSelector((state) => state.auth);
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    // Check token expiry whenever accessing a protected route
    if (isAuthenticated && isTokenExpired()) {
      toast.info('Your session has expired. Please log in again.', {
        className:
          'bg-[var(--yellow-primary)] text-black text-sm px-1 py-1 rounded-md min-h-0',
        duration: 3000,
      });
      dispatch(logout());
    }
  }, [isAuthenticated, dispatch, location.pathname]);

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
